import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'

import { AddAuthSession, _axios } from 'hooks/axios'
import { AssignWithContract } from 'types/assign'
import { Security } from 'types/security'

const GET_ME = `/me`
const AUTH = `/auth`
const SIGNIN = `/signin`
const FILTER_ASSIGN_BY_DATE = `/securities/assign`

export const securityApi = () => {
  const getMe = async (): Promise<AxiosResponse<Security>> => {
    return await _axios()
      .get(GET_ME)
      .then((res) => {
        res.data = res.data.security
        return res
      })
  }

  const filterAssignByDate = async (
    date: string,
  ): Promise<AxiosResponse<AssignWithContract>> => {
    return await _axios()
      .get(FILTER_ASSIGN_BY_DATE, {
        params: {
          date: date,
        },
      })
      .then((res) => {
        res.data = res.data
        const cd = res.data.contractDetail
        cd.startDate = dayjs(cd.startDate)
        cd.endDate = dayjs(cd.endDate)
        cd.startTime = dayjs(cd.startTime)
        cd.endTime = dayjs(cd.endTime)
        return res
      })
  }

  const authKumocan = async (
    pass: string,
  ): Promise<AxiosResponse<AssignWithContract>> => {
    return await _axios()
      .post(AUTH, { password: pass })
      .then((res) => {
        res.data = res.data
        return res
      })
  }

  const signIn = async (
    id: string,
    pass: string,
  ): Promise<AxiosResponse<AssignWithContract>> => {
    return await _axios()
      .post(SIGNIN, {
        loginID: id,
        password: pass,
      })
      .then((res) => {
        res.data = res.data
        AddAuthSession(res.data.accessToken)
        return res
      })
  }

  return {
    getMe,
    filterAssignByDate,
    signIn,
    authKumocan,
  }
}
